var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import * as $ from "jquery";
import "fullcalendar";
import * as moment from "moment";
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Calendar.prototype, "events", {
        get: function () {
            return this.$slots.default.slice().filter(function (p) { return p.componentOptions; })
                .map(function (p) { return { component: new p.componentOptions.Ctor(p.componentOptions), vnode: p }; })
                .map(function (p) {
                p.component.$vnode = p.vnode;
                return p.component;
            })
                .filter(function (p) { return p._isCalendarEvent === true; })
                .map(function (p) {
                for (var ev in p.$options.listeners) {
                    p.$on(ev, p.$options.listeners[ev]);
                }
                return p;
            })
                .map(function (p) { return p.event; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "minEvent", {
        get: function () {
            return this.events
                .map(function (p) { return p.start.clone(); })
                .sort(function (l, r) { return l.valueOf() - r.valueOf(); })[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "minTime", {
        get: function () {
            return this.events
                .map(function (p) { return p.start.clone(); })
                .map(function (p) { return p.subtract(1, "Hours").startOf("hour"); })
                .map(function (p) { return p.diff(p.clone().startOf("day")); })
                .sort()
                .map(function (p) { return moment.duration(p); })[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "maxEvent", {
        get: function () {
            return this.events
                .map(function (p) { return p.end.clone(); })
                .sort(function (l, r) { return l.valueOf() - r.valueOf(); }).reverse()[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "maxTime", {
        get: function () {
            return this.events
                .map(function (p) { return p.end.clone(); })
                .map(function (p) { return p.add(1, "Hours").endOf("hour"); })
                .map(function (p) { return p.diff(p.clone().startOf("day")); })
                .sort().reverse()
                .map(function (p) { return moment.duration(p); })[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "duration", {
        get: function () {
            return this.maxEvent.endOf("Day").diff(this.minEvent.startOf("Day"), "Days") + 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "now", {
        get: function () {
            return moment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "isNowInEvents", {
        get: function () {
            if (!this.minEvent || !this.maxEvent)
                return false;
            return this.now.isBetween(this.minEvent, this.maxEvent, "day", "[]");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "defaultDate", {
        get: function () {
            if (this.isNowInEvents)
                return this.now;
            else if (this.minEvent)
                return this.minEvent;
            else
                return this.now;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "defaultView", {
        get: function () {
            if (this.isNowInEvents)
                return "agendaDay";
            else
                return "bestFit";
        },
        enumerable: true,
        configurable: true
    });
    Calendar.prototype.mounted = function () {
        var _this = this;
        var headerLeft = !this.$slots["header-left"] ? this.headerLeft : "";
        var headerCenter = !this.$slots["header-center"] ? this.headerCenter : "";
        var headerRight = !this.$slots["header-right"] ? this.headerRight : "";
        // Remove slots container so it does not get pulled into the calendar content.
        //
        var slots = this.$refs.slots;
        slots.parentElement.removeChild(slots);
        var root = this.$refs.root;
        root.id = safeId();
        waitForVisible(root.id, function () {
            $(root).fullCalendar({
                header: {
                    left: headerLeft,
                    center: headerCenter,
                    right: headerRight
                },
                events: _this.events,
                allDaySlot: _this.allDaySlot,
                defaultDate: _this.date || _this.defaultDate,
                defaultView: _this.view || _this.defaultView,
                minTime: _this.minTime && moment("2000-01-01").add(_this.minTime).format("HH:mm:ss"),
                maxTime: _this.maxTime && moment("2000-01-01").add(_this.maxTime).format("HH:mm:ss"),
                views: {
                    bestFit: {
                        type: "agenda",
                        duration: { days: _this.duration },
                        buttonText: _this.bestFitText
                    }
                },
                viewRender: function (view, element) {
                    var viewClasses = Array.from(element[0].classList)
                        .filter(function (p) { return p.match(/^fc-.+-view$/i); })
                        .map(function (p) { return p.substr("fc-".length); });
                    Array.from(root.classList)
                        .filter(function (p) { return p.match(/^.+-view/i); })
                        .forEach(function (p) { return root.classList.remove(p); });
                    viewClasses.forEach(function (p) { return root.classList.add(p); });
                    var currentDate = $(root).fullCalendar("getDate");
                    var prev = root.querySelector(".fc-prev-button:not(.fc-custom)");
                    if (prev) {
                        prev.classList.remove("fc-state-disabled");
                        if (currentDate.isSameOrBefore(_this.minEvent.startOf("Day"), "day")) {
                            prev.classList.add("fc-state-disabled");
                        }
                    }
                    var next = root.querySelector(".fc-next-button:not(.fc-custom)");
                    if (next) {
                        next.classList.remove("fc-state-disabled");
                        if (currentDate.isSameOrAfter(_this.maxEvent.startOf("Day"), "day")) {
                            next.classList.add("fc-state-disabled");
                        }
                    }
                    if (view.name === "bestFit") {
                        setTimeout(function () {
                            $(root).fullCalendar("gotoDate", _this.minEvent);
                        }, 1);
                    }
                    if (_this.$slots["header-left"]) {
                        var leftContainer = root.querySelector(".fc-left");
                        if (leftContainer) {
                            while (leftContainer.firstChild) {
                                leftContainer.removeChild(leftContainer.firstChild);
                            }
                            leftContainer.appendChild(_this.$slots["header-left"][0].elm);
                        }
                    }
                    if (_this.$slots["header-center"]) {
                        var centerContainer = root.querySelector(".fc-center");
                        if (centerContainer) {
                            while (centerContainer.firstChild) {
                                centerContainer.removeChild(centerContainer.firstChild);
                            }
                            centerContainer.appendChild(_this.$slots["header-center"][0].elm);
                        }
                    }
                    if (_this.$slots["header-right"]) {
                        var rightContainer = root.querySelector(".fc-right");
                        if (rightContainer) {
                            while (rightContainer.firstChild) {
                                rightContainer.removeChild(rightContainer.firstChild);
                            }
                            rightContainer.appendChild(_this.$slots["header-right"][0].elm);
                        }
                    }
                },
                eventClick: function (event) {
                    event.$component.$emit("click");
                },
                eventRender: function (event, element) {
                    var eventOptions = event.$component.$options;
                    if (!eventOptions.children)
                        return;
                    var title = element[0].querySelector(".fc-title");
                    if (!title) {
                        title = document.createElement("div");
                        title.className = "fc-title";
                        var time = element[0].querySelector(".fc-time");
                        if (time && time.nextSibling) {
                            time.parentNode.insertBefore(title, time.nextSibling);
                        }
                        else if (time) {
                            time.parentNode.appendChild(title);
                        }
                    }
                    while (title.firstChild) {
                        title.removeChild(title.firstChild);
                    }
                    for (var i = 0; i < eventOptions.children.length; i++) {
                        title.appendChild(eventOptions.children[i].elm);
                    }
                }
            });
        });
    };
    __decorate([
        Prop({ type: String, default: "prev,next today" })
    ], Calendar.prototype, "headerLeft", void 0);
    __decorate([
        Prop({ type: String, default: "title" })
    ], Calendar.prototype, "headerCenter", void 0);
    __decorate([
        Prop({ type: String, default: "bestFit,agendaDay" })
    ], Calendar.prototype, "headerRight", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Calendar.prototype, "allDaySlot", void 0);
    __decorate([
        Prop({ type: String, default: "week" })
    ], Calendar.prototype, "bestFitText", void 0);
    __decorate([
        Prop({ type: String })
    ], Calendar.prototype, "view", void 0);
    __decorate([
        Prop({ type: Object })
    ], Calendar.prototype, "date", void 0);
    Calendar = __decorate([
        Component({
            name: "Calendar"
        })
    ], Calendar);
    return Calendar;
}(Vue));
export default Calendar;
;
var lastSafeId = 0;
function safeId() {
    return "Calendar_" + lastSafeId++;
}
function waitForVisible(id, callbackFn) {
    if ($("#" + id).is(":visible")) {
        setTimeout(function () { return callbackFn(); }, 1);
        return;
    }
    setTimeout(waitForVisible.bind(this, id, callbackFn), 1000);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Calendar.vue
// module id = 278
// module chunks = 0 1